import { isValidBase } from '../BaseEntity';
export const isValidFileSystem = properties => isValidBase(properties);
//# sourceMappingURL=FileSystem.js.map